import { render, staticRenderFns } from "./company-card.vue?vue&type=template&id=6586931a&scoped=true&"
import script from "./company-card.vue?vue&type=script&lang=js&"
export * from "./company-card.vue?vue&type=script&lang=js&"
import style0 from "./company-card.vue?vue&type=style&index=0&id=6586931a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586931a",
  null
  
)

export default component.exports